import { Fragment, useMemo } from 'react';
import type { PdfComponentAltTextI } from '../typed';

const TermsAndConditionsRenderAlternatingText: React.FunctionComponent<PdfComponentAltTextI> =
  function ({ content, boldFirst = true }) {
    const sections = useMemo(
      () =>
        content.map((text, index) => ({
          text,
          isBold: index % 2 === (boldFirst ? 0 : 1), // ? true : false,
        })),
      [content, boldFirst],
    );

    return (
      <span className="text-12-18 md:text-14-22">
        {sections.map((section) => {
          if (section.isBold) {
            return <b key={section.text}>{section.text}</b>;
          }
          return <Fragment key={section.text}>{section.text}</Fragment>;
        })}
      </span>
    );
  };

export default TermsAndConditionsRenderAlternatingText;
